import { useMutation, UseMutationResult } from '@tanstack/react-query';
import multiChannelApi from '../../../lib/api/multiChannel/multiChannelApi';
import { OrderExcelUploadItem } from '../../../types/multiChannel';

const createFormData = (payload: File): FormData => {
  const formData = new FormData();
  formData.append('file', payload);
  return formData;
};

// todo: 스웨거에 정의된 타입이 명확하지 않아 임시로 클라이언트에서 생성한 타입 사용합니다 문서 변경 후 타입 변경 필요 (스웨거에 object로 표시되어 제대로 된 타입 추론이 불가능)
export const useOrderItemsExcelUpload = (): UseMutationResult<
  { multiChannelOrderItems: Omit<OrderExcelUploadItem, 'id'>[] },
  unknown,
  File,
  unknown
> => {
  return useMutation((payload: File) => multiChannelApi.orderItemsExcelUpload(createFormData(payload)));
};
